import { render, staticRenderFns } from "./BookingListView.vue?vue&type=template&id=6b5b3f9e&scoped=true"
import script from "./BookingListView.vue?vue&type=script&lang=js"
export * from "./BookingListView.vue?vue&type=script&lang=js"
import style0 from "./BookingListView.vue?vue&type=style&index=0&id=6b5b3f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b3f9e",
  null
  
)

export default component.exports